$(document).ready(function () {
    $('#modalAttachArticuloPlantillaBotonAdjuntar').on('click', function () {
        attachArticuloAPlantilla();
    });
});

window.mostrarModalAttachAPlantilla = function (articuloId, articuloUnidades, obj) {
    $("#attachArticuloPlantillaCampoIdArticulo").val(articuloId);
    let cantidad;

    if (articuloUnidades > 0) {
        cantidad = $(`#product-id-${articuloId}`).find('.select-editable-units input').val().split('-')[0];
    } else {
        cantidad = $(`#product-id-${articuloId}`).find('.product-quantity-input input').val();
    }

    $("#attachArticuloPlantillaCampoCantidad").val(cantidad);
    getPlantillas();
    toggleMoreActions('#btn-multiple' + articuloId);
}

window.getPlantillas = async function (idPlantilla = null) {
    $.ajax({
        url:        urlPlantilla + '/get',
        type:       'POST',
        dataType:   'json',
        beforeSend: function beforeSend() {
            $("#modalAttachArticuloPlantilla .loadingResults").show();
            $("#modalAttachArticuloPlantilla .sinResultados").hide();
            $("#modalAttachArticuloPlantillaBotonAdjuntar").attr('disabled', true);
            $("#attachArticuloPlantillaFormulario")
                .hide()
                .find('select')
                .html(``)
                .attr('disabled', true);
        },
    })
     .done(function (response) {
         if (response.list.length) {
             let html = '';
             response.list.forEach(plantilla => {
                 html += `<option value="${plantilla.id}">${plantilla.titulo}</option>`;
             });
             $("#attachArticuloPlantillaFormulario")
                 .show()
                 .find('select')
                 .html(html)
                 .attr('disabled', false);
             $("#modalAttachArticuloPlantilla .sinResultados").hide();
             $("#modalAttachArticuloPlantillaBotonAdjuntar").attr('disabled', false);
             if (idPlantilla) {
                 $('#attachArticuloPlantillaFormulario select').val(idPlantilla);
             }
         } else {
             $("#modalAttachArticuloPlantilla .sinResultados").show();
         }
     })
     .fail(function (jqXHR, status, error) {
         if (jqXHR.status) {
             var errors = '';
             if (jqXHR.status === 422) {
                 errors = composeValidationError(jqXHR.responseJSON.errors);
             } else if (jqXHR.responseJSON.message) {
                 errors = jqXHR.responseJSON.message;
             }
             pNotifyError(errors);
         }
     })
     .always(function () {
         $("#modalAttachArticuloPlantilla .loadingResults").hide();
     });
}

window.attachArticulosAPlantillaDB = function (idPlantilla, dataToSend) {
    $.ajax({
        url:        urlPlantilla + '/' + idPlantilla + '/sync/articulos',
        type:       'POST',
        data:       dataToSend,
        dataType:   'json',
        beforeSend: function beforeSend() {
            $('#modalAttachArticuloPlantillaBotonAdjuntar').prop('disabled', true);
            $('#modalAttachArticuloPlantillaBotonAdjuntar').html("<i class=\"ri-loader-4-line ri-formatted spinner\"></i>".concat(transAccionProcesando));
        }
    })
     .done(function (response) {
         pNotifySuccess(response.message);
         $('#modalAttachArticuloPlantillaBotonCerrar').click();
     })
     .fail(function (jqXHR, status, error) {
         if (jqXHR.status === 422) {
             errors = composeValidationError(jqXHR.responseJSON.errors);
         } else if (jqXHR.responseJSON.message) {
             errors = jqXHR.responseJSON.message;
         } else {
             errors = error;
         }
         pNotifyError(errors);
     })
     .always(function () {
         $('#modalAttachArticuloPlantillaBotonAdjuntar').prop('disabled', false);
         $('#modalAttachArticuloPlantillaBotonAdjuntar').html("<i class=\"ri-send-plane-2-fill ri-formatted\"></i>".concat(transAccionAnadirAPlantilla));
     });
}

window.attachArticuloAPlantilla = function () {

    if (!$('#attachArticuloPlantillaFormulario')[0].checkValidity()) {
        $("<input type=\"submit\">")
            .hide()
            .appendTo('#attachArticuloPlantillaFormulario')
            .click()
            .remove();
    } else {
        cleanFeedback('attachArticuloPlantilla', 'attachArticuloPlantillaFormulario');
        const idPlantilla = $('#attachArticuloPlantillaCampoId').val();
        const id          = $('#attachArticuloPlantillaCampoIdArticulo').val();
        const cantidad    = $('#attachArticuloPlantillaCampoCantidad').val();

        const dataToSend = {
            sync_id:      {
                [id]: {cantidad},
            },
            detaching:    0,
            incrementing: 0
        }
        attachArticulosAPlantillaDB(idPlantilla, dataToSend);
    }

}
